import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useUser } from "../../../context/UserContext";
import "./Adminlogin.css";

export default function Login({ onLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [authCode, setAuthCode] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { setUser } = useUser();
  const apiUrl = process.env.REACT_APP_API_URL;

  const handleLogin = async e => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await fetch(`${apiUrl}/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password, auth_code: authCode })
      });
      const data = await res.json();
      if (res.ok) {
        onLogin && onLogin(data.user);
        localStorage.setItem("token", data.token);
        // Fetch user info and update context
        fetch(`${apiUrl}/user`, {
          headers: {
            Authorization: `Bearer ${data.token}`,
            Accept: "application/json",
          },
          credentials: "include",
        })
          .then(res => res.json())
          .then(data => {
            setUser(data);

          });
        navigate("/admin/mainpage");
        
      } else {
        setError(data.error || data.message || "Hibás adatok!");
      }
    } catch (error) {
      setError(`Hiba történt a bejelentkezéskor. ${error.message}`);
    }
    setLoading(false);
  };

  return (
    <div className="login-container">
      <h2>Bejelentkezés</h2>
      <form className="login-form" onSubmit={handleLogin}>
        <label>Felhasználónév:
          <input type="text" value={username} onChange={e => setUsername(e.target.value)} required />
        </label>
        <label>Jelszó:
          <input type="password" value={password} onChange={e => setPassword(e.target.value)} required />
        </label>
        <label>Authentikátor kód:
          <input type="text" value={authCode} onChange={e => setAuthCode(e.target.value)} required />
        </label>
        <button type="submit" disabled={loading}>{loading ? "Bejelentkezés..." : "Bejelentkezés"}</button>
      </form>
      {error && <div className="login-error">{error}</div>}
    </div>
  );
}
